// extracted by mini-css-extract-plugin
export default {"container":"ReceiptDialog_container__qivXg","image":"ReceiptDialog_image__CgMAi"};